import { any, map, propEq, reject, pipe, prop, equals, not, allPass } from 'ramda';
import React, { FC, useMemo } from 'react';
import { useMMGRSettings } from '../../../../utils/hoc/withMMGRSettings';
import { useBoards } from '../../../../utils/hooks/useBoards';
import { MediaManagerSDKAnyItem, MediaManagerSDKBoard } from '../../../../utils/media-manager-sdk';
import { isCurrentSiteOnlyBoard } from '../../../../utils/media-manager-sdk/boards';
import { parseSiteMediaToken } from '../../../../utils/siteMediaToken';
import { Loader } from '../../index';
import { BoardListItem } from '../BoardListItem';
import styles from '../BoardsContextMenu.scss';
import { IOuter } from './BoardsList.types';

const prepareBoards = (
  boards: MediaManagerSDKBoard[],
  itemsToAdd: MediaManagerSDKAnyItem[],
  metaSiteId: string,
): MediaManagerSDKBoard[] => {
  const isFileFromOtherSite = pipe(prop('siteId'), equals(metaSiteId), not);

  const isItemSiteIdDefined = pipe(prop('siteId'), Boolean);

  const showPublicBoardsOnly = any(allPass([isFileFromOtherSite, isItemSiteIdDefined]))(itemsToAdd);

  if (showPublicBoardsOnly) {
    return reject(isCurrentSiteOnlyBoard, boards);
  }

  return boards;
};

export const BoardsList: FC<IOuter> = ({ itemsToAdd }) => {
  const { boards, isLoading, boardsOfItem } = useBoards();
  const {
    mmgrSettings: { siteMediaToken },
  } = useMMGRSettings();

  const metaSiteId = parseSiteMediaToken(siteMediaToken).metaSiteId;

  const boardsToShow = useMemo(
    () => prepareBoards(boards, itemsToAdd, metaSiteId),
    [boards, itemsToAdd, metaSiteId, prepareBoards],
  );

  if (isLoading) {
    return (
      <div className={styles.loader} data-hook="boards-context-menu-loader">
        <Loader size="small" />
      </div>
    );
  }

  return (
    <div className={boards.length > 5 ? styles.addScroll : ''}>
      {map(
        (board) => (
          <BoardListItem
            board={board}
            itemsToAdd={itemsToAdd}
            key={board.id}
            hasItems={any(propEq('id', board.id), boardsOfItem)}
          />
        ),
        boardsToShow,
      )}
    </div>
  );
};
